import React from "react";
import {css} from "@panda/css";
import {visuallyHidden} from "@panda/patterns";

import {ILocationGenericParagraphTable} from "../../../helpers/location_generic_description/constants";

interface IProps {
    caption: ILocationGenericParagraphTable["caption"];
    captionHidden?: ILocationGenericParagraphTable["captionHidden"];
    headers: ILocationGenericParagraphTable["headers"];
    rows: ILocationGenericParagraphTable["rows"];
}

export const ParagraphTableType = ({caption, captionHidden, headers, rows}: IProps) => {
    return (
        <div className={tableOuterStyle}>
            <div className={tableScrollStyle}>
                <table className={tableStyle}>
                    <caption className={captionStyle}>
                        {caption}
                        {captionHidden ? <span className={visuallyHidden()}> {captionHidden}</span> : null}
                    </caption>
                    <thead>
                        <tr>
                            {headers.map((header, index) => (
                                <th key={index} className={thStyle}>
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell, cellIndex) => (
                                    <td key={cellIndex} className={tdStyle}>
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const tableOuterStyle = css({
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflow: "hidden",
    marginTop: 2,
    marginBottom: 2
});

const tableScrollStyle = css({
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflowX: "auto"
});

const tableStyle = css({
    width: "100%",
    borderCollapse: "collapse"
});

const captionStyle = css({
    position: "relative",
    textAlign: "left",
    fontWeight: "bold",
    marginBottom: 1
});

const thStyle = css({
    textAlign: "left",
    py: 1,
    px: 1.5,
    borderBottom: "2px solid var(--colors-gray-300)",
    fontWeight: "bold",
    whiteSpace: "nowrap"
});

const tdStyle = css({
    textAlign: "left",
    py: 1,
    px: 1.5,
    borderBottom: "1px solid var(--colors-gray-200)"
});
import React from "react";
import {css} from "@panda/css";
import {visuallyHidden} from "@panda/patterns";

import {ILocationGenericParagraphTable} from "../../../helpers/location_generic_description/constants";

interface IProps {
    caption: ILocationGenericParagraphTable["caption"];
    captionHidden?: ILocationGenericParagraphTable["captionHidden"];
    headers: ILocationGenericParagraphTable["headers"];
    rows: ILocationGenericParagraphTable["rows"];
}

export const ParagraphTableType = ({caption, captionHidden, headers, rows}: IProps) => {
    return (
        <div className={tableOuterStyle}>
            <div className={tableScrollStyle}>
                <table className={tableStyle}>
                    <caption className={captionStyle}>
                        {caption}
                        {captionHidden ? <span className={visuallyHidden()}> {captionHidden}</span> : null}
                    </caption>
                    <thead>
                        <tr>
                            {headers.map((header, index) => (
                                <th key={index} className={thStyle}>
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell, cellIndex) => (
                                    <td key={cellIndex} className={tdStyle}>
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const tableOuterStyle = css({
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflow: "hidden",
    marginTop: 2,
    marginBottom: 2
});

const tableScrollStyle = css({
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflowX: "auto"
});

const tableStyle = css({
    width: "100%",
    borderCollapse: "collapse"
});

const captionStyle = css({
    position: "relative",
    textAlign: "left",
    fontWeight: "bold",
    marginBottom: 1
});

const thStyle = css({
    textAlign: "left",
    py: 1,
    px: 1.5,
    borderBottom: "2px solid var(--colors-gray-300)",
    fontWeight: "bold",
    whiteSpace: "nowrap"
});

const tdStyle = css({
    textAlign: "left",
    py: 1,
    px: 1.5,
    borderBottom: "1px solid var(--colors-gray-200)"
});
